import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/workforce` — fino al 02-11-2026 era «Segreteria & HR», una pagina a sette schede. Le schede erano
 * doppie di altre voci (Dipendenti, Sedi e Gruppi in «Organizzazione DP»; Chi c'è oggi, Formazione e
 * il cruscotto in «Risorse umane») e le Sale sono passate in «Area segreteria». L'indirizzo resta
 * come rinvio all'elenco dei dipendenti, per i preferiti e i collegamenti salvati.
 */
export const Route = createFileRoute('/_app/workforce/')({
  beforeLoad: () => { throw redirect({ to: '/hr/employees', replace: true }); },
});
